import { Wifi, WifiOff, Download, CheckCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useOfflineStorage } from '@/hooks/useOfflineStorage';
import { usePWA } from '@/hooks/usePWA';

export const PWAStatusBar = () => {
  const { isOnline, pendingActions } = useOfflineStorage();
  const { isInstallable, isInstalled, installApp } = usePWA();
  const installBannerEnabled = String((import.meta as any)?.env?.VITE_ENABLE_PWA_INSTALL_BANNER ?? '').toLowerCase() === 'true';

  if (isOnline && (!pendingActions || pendingActions === 0) && !isInstallable) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 space-y-1 p-2">
      {/* Offline Status */}
      {!isOnline && (
        <Alert className="bg-red-50 border-red-200 text-red-800">
          <WifiOff className="h-4 w-4" />
          <AlertDescription className="text-sm">
            You're offline. Changes will sync when connection is restored.
          </AlertDescription>
        </Alert>
      )}

      {/* Pending Actions */}
      {(pendingActions && pendingActions > 0) && (
        <Alert className="bg-yellow-50 border-yellow-200 text-yellow-800">
          <CheckCircle className="h-4 w-4" />
          <AlertDescription className="flex items-center justify-between">
            <span className="text-sm">
              {pendingActions} actions pending sync
            </span>
            <Badge variant="secondary" className="text-xs">
              {isOnline ? 'Syncing...' : 'Offline'}
            </Badge>
          </AlertDescription>
        </Alert>
      )}

      {/* Install Prompt (disabled by default; enable via VITE_ENABLE_PWA_INSTALL_BANNER=true) */}
      {installBannerEnabled && isInstallable && !isInstalled && (
        <Alert className="bg-blue-50 border-blue-200 text-blue-800">
          <Download className="h-4 w-4" />
          <AlertDescription className="flex items-center justify-between">
            <span className="text-sm">Install BillPortal for better experience</span>
            <Button
              size="sm"
              variant="outline"
              onClick={installApp}
              className="h-6 text-xs border-blue-300 text-blue-700 hover:bg-blue-100"
            >
              Install
            </Button>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};